module.exports = __webpack_public_path__ + "img/Upper_Elementary_School.aae01990.svg";